import { render, staticRenderFns } from "./AppSearchResultRecent.vue?vue&type=template&id=2fe25ef1"
import script from "./AppSearchResultRecent.vue?vue&type=script&lang=js"
export * from "./AppSearchResultRecent.vue?vue&type=script&lang=js"
import style0 from "./AppSearchResultRecent.vue?vue&type=style&index=0&id=2fe25ef1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports